module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA9klEQVQ4T7WSv2oCQRCHf7M5OEGJ6DXmQDFKYinJg8TH0EeKL+MfUCySGNIGCxUvOS+FUS/l7YTdoKDZYhGcaov5+O18M9QfjR9kIttEVIBFMXMoLkSTuoPnz9rtTSGTSVtgQBz/4H0yCak3fOH7u7oVtGsav77hvGCSJFivN8jnczrUKpGZMZ3O4LoufP/KDlTQYhFASolSqQgiMoNB8AHP85BKubphuYyw3caoVMoQQuwF/vvqavWNKPpCtXqtgd3bcZwD68YZVYoSoYSoJDXbcRnBPxlzbTCbvTTu18qqidTgySfXGT41BItHEKyOHIxQkmz9Ajmun+6LC4NnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_sign.png
// module id = mvWz
// module chunks = 1